import React = require("react");
import Switch, {ReactSwitchProps} from "react-switch";
import {ToolbarContextInterface} from "../toolsbar/ToolbarContext";
import {defaultTheme} from "@vebox/etui-themes";
import {ThemeProvider} from "@vebox/etui-system";
import {veboxDefaultTheme} from "../../index";
import {Toggle} from "@vebox/etui-core";

export interface SwitchCardProps {
    onChange: any;
    checked: boolean;
    label: string;
    uncheckedIconClass?: string;
    checkedIconClass?: string;
    backgroundColor?: string;
    textColor?: string;
}

export class SwitchCard extends React.Component<SwitchCardProps> {
    constructor(props) {
        super(props);
    }

    public render() {
        return (
            <div
                style={{
                    padding: 5,
                    // background: this.props.backgroundColor ? this.props.backgroundColor : "rgb(174 176 196 / 27%)",
                    borderRadius: 5,
                    // width: "min-content",
                }}
            >
                <label
                    className={"switch-scale-dynamic"}
                    style={{
                        fontSize: 15,
                        justifyContent: "end",
                        alignItems: "center",
                        display: "flex",
                    }}
                >
                    <div
                        className={"switchLabel"}
                        style={{
                            paddingRight: 10,
                            color: this.props.textColor ? this.props.textColor : "white",
                        }}
                    >
                        {this.props.label}
                    </div>
                    <Toggle
                        name={this.props.label}
                        isChecked={this.props.checked}
                        onChange={
                            // tslint:disable-next-line:jsx-no-lambda
                            (p, isChecked) => this.propsOnChange(p, isChecked)
                        }
                    />
                </label>
            </div>
        );
    }

    private propsOnChange(p, isChecked) {
        this.props.onChange(isChecked);
    }
}
